




























import Header from '@/components/Header.vue';
import { Video } from '@/types/Video';
import Vue from 'vue';
import 'vuex';
import { mapGetters } from 'vuex';

export default Vue.extend({
    name: 'Videos',
    components: { Header },
    data: () => ({
        tab: null,
    }),
    computed: {
        ...mapGetters(['finishedVideos']),
    },
    methods: {
        goToVideo(video: Video) {
            this.$router.push(`/videos/${video.id}`);
        },
    },
});
